// CHIRHOS
export const SET_CHIRHOS_CONFIG = `SET_CHIRHOS_CONFIG`

// USER
export const SET_PROFILE = `SET_PROFILE`
export const SET_ACCESS = `SET_ACCESS`
export const INITIALIZE = `INITIALIZE`
